<template>
    <div class="container-fluid search-view">
        <div class="col-12 p-0">
            <div class="row">
                <div class="col-lg-3 col-12 col-md-6">
                    <SearchViewFilter :change-view="changeView">
                    </SearchViewFilter>
                </div>
                <div class="p-0 col-lg-9 col-12 col-md-6">
                    <template>
                        <SearchViewResults
                                :resultsprop="results"
                                :current_page="current_page"
                                :next_page_url="next_page_url"
                                :prev_page_url="next_page_url"
                                :coursefounded="coursefounded"
                                v-show="selectedView == 'list'">
                        </SearchViewResults>
                        <SearchViewMap :resultsprop="results" :show="selectedView == 'map'">
                        </SearchViewMap>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import SearchViewFilter from './SearchViewFilter'
    import SearchViewResults from './SearchViewResults'
    import SearchViewMap from './SearchViewMap'

    export default {
        name: "SearchView",
        components: {
            SearchViewFilter,
            SearchViewResults,
            SearchViewMap
        },
        props: {
            current_page: null,
            next_page_url: null,
            prev_page_url: null,
            results: {
                type: Array,
                default: []
            },
            coursefounded: 0
        },
        data() {
            return {
                selectedView: 'list'
            }
        },
        methods: {
            changeView(view) {
                this.selectedView = view;
                if (view === 'map') {
                    setTimeout(window.fitBounds, 2000);
                }

            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/search/SearchView.vue